import { CoordinatorService } from './coordinator.service';
import { ScriptTags } from './script-tags';

export class ScriptHub {
    #coords: CoordinatorService;
    #keywordBT?: ScriptTags;

    constructor(coords: CoordinatorService) {
        this.#coords = coords;
        fetch('/assets/hub_keywords.json')
            .then((x) => x.json())
            .then((ls: any[]) => {
                this.#keywordBT = this.#coords.script$
                    .tags('HUB KEYWORDS', true)!
                    .createNodesFromTemplate(ls);
                console.log('Hub keywords loaded', this.#keywordBT);
            });
    }

    get keywordTags() {
        return this.#keywordBT
    }
}
